function plenaInitTierPickers() {
  var groups = document.querySelectorAll('.plena-pdp-tiers');
  if (!groups.length) return;

  groups.forEach(function (group) {
    var tiers = group.querySelectorAll('.plena-pdp-tier[data-variant-id]');

    function selectTier(tier, triggerNative) {
      tiers.forEach(function (t) {
        t.classList.remove('is-selected');
        t.setAttribute('aria-checked', 'false');
      });
      tier.classList.add('is-selected');
      tier.setAttribute('aria-checked', 'true');
      if (triggerNative) {
        var variantId = tier.getAttribute('data-variant-id');
        var nativeInput = document.querySelector('variant-picker input[data-variant-id="' + variantId + '"]');
        if (nativeInput && !nativeInput.checked) {
          nativeInput.click();
        }
      }
    }

    tiers.forEach(function (tier) {
      tier.addEventListener('click', function () { selectTier(tier, true); });
      tier.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectTier(tier, true);
        }
      });
    });

    var defaultTier = group.querySelector('.plena-pdp-tier[data-default="true"]') || tiers[0];
    if (defaultTier) selectTier(defaultTier, true);
  });
}

document.addEventListener('DOMContentLoaded', function () {
  setTimeout(plenaInitTierPickers, 50);

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var els = document.querySelectorAll('[data-plena-reveal]');

  if (reduceMotion || !('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('is-visible'); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
  );

  els.forEach(function (el) { observer.observe(el); });

  var countEls = document.querySelectorAll('[data-count-to]');
  if (countEls.length && !reduceMotion) {
    var countObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          countObserver.unobserve(entry.target);
          var el = entry.target;
          var target = parseFloat(el.getAttribute('data-count-to'));
          var duration = 900;
          var start = null;
          function step(timestamp) {
            if (start === null) start = timestamp;
            var progress = Math.min((timestamp - start) / duration, 1);
            var eased = 1 - Math.pow(1 - progress, 3);
            el.textContent = Math.round(eased * target);
            if (progress < 1) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
        });
      },
      { threshold: 0.4 }
    );
    countEls.forEach(function (el) { countObserver.observe(el); });
  }

  var hasFinePointer = window.matchMedia('(pointer: fine)').matches;
  if (reduceMotion || !hasFinePointer) return;

  var maxTilt = 10;
  var tiltCards = document.querySelectorAll('[data-plena-tilt]');

  tiltCards.forEach(function (card) {
    function handleMove(e) {
      var rect = card.getBoundingClientRect();
      var px = (e.clientX - rect.left) / rect.width;
      var py = (e.clientY - rect.top) / rect.height;
      var rotateY = (px - 0.5) * maxTilt * 2;
      var rotateX = (0.5 - py) * maxTilt * 2;
      card.style.setProperty('--plena-tilt-x', rotateX.toFixed(2) + 'deg');
      card.style.setProperty('--plena-tilt-y', rotateY.toFixed(2) + 'deg');
      card.style.setProperty('--plena-glare-x', (px * 100).toFixed(1) + '%');
      card.style.setProperty('--plena-glare-y', (py * 100).toFixed(1) + '%');
    }
    function handleLeave() {
      card.style.setProperty('--plena-tilt-x', '0deg');
      card.style.setProperty('--plena-tilt-y', '0deg');
    }
    card.addEventListener('mousemove', handleMove);
    card.addEventListener('mouseleave', handleLeave);
  });
});
